export default "__VITE_ASSET__BQqtWaOz__"